// extracted by mini-css-extract-plugin
export var cardContainer = "Card-module--cardContainer--a564a";
export var zoomable = "Card-module--zoomable--94f9a";